import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, CardFooter, CardText, Col, Row } from 'reactstrap';
import firebase from "../../firebase/firebase-config";


const ProductCard = ({ data }) => {

    const [user, setuser] = useState({})
    const [date, setdate] = useState('')
    const [reviews, setreviews] = useState([])
    const [reviewRatings, setreviewRatings] = useState(0)


    const get_user = async () => {
        const user = firebase.firestore().collection('users').doc(data.userId).onSnapshot((user) => {

            setuser(user.data());


        })
        await firebase.firestore().collection('post').doc(data?.id).onSnapshot((post) => {
            // console.log(post.data()['reviews'])
            const productReviews = [];
            post.data()['reviews'].forEach(element => {
                productReviews.push(element);
            });
            // console.log(productReviews, 'this is reviews')
            setreviews(productReviews);

            const ReviewRatings = [];


            ReviewRatings.push(productReviews.rating)
            const reviewCount = ReviewRatings.length / productReviews.length
            // console.log(reviewCount);
            // setreviewRatings(reviewCount);


        })

        // const date = new Date(data.date.seconds * 1000 + data.date.nanoseconds / 1000000);
        // setdate(date.toString());

    }

    useEffect(() => {
        get_user();
    }, [])



    return (




        <Col md="4" key={data?.orderId}>
            <Card className="card-user shadow-lg">
                <CardBody>
                    <CardText />


                    <div className="d-flex justify-content-around" onClick={(e) => e.preventDefault()}>
                        {data?.showPost == false && data?.isRemoved == true ? <p className='bg-danger px-1 py-1 rounded'>InActive</p> : <p className='bg-success px-1 py-1 rounded'>Active</p>}
                        <h6 className="title ">Product ID : {data?.id}</h6>
                        <hr />
                        {/* <h5 className="description">Order date: {data.date}</h5> */}
                    </div>
                    <div>
                        {/* <div className="d-flex" style={{ color: 'white' }}>
                            Current Status : {data?.status == 'pending' ? <p className="font-weight-bold px-3 ml-2" style={{ background: 'linear-gradient(90deg, rgba(0,159,253,1) 0%, rgba(42,42,114,1) 100%)', borderRadius: '8px' }}>Pending</p> : data?.status == 'approved' ? <p className="font-weight-bold px-3 ml-2" style={{ background: ' linear-gradient(to right, #04FF00, #00FFAE)', borderRadius: '8px' }}>Approved</p> : data?.status == 'production' ? <p className="font-weight-bold px-3 ml-2" style={{ background: 'linear-gradient(to right, #FEE823, #9E9333)', borderRadius: '8px' }}>production</p> : data?.status == 'shipped' ? <p className="font-weight-bold px-3 ml-2" style={{ background: 'linear-gradient(to right, #606c88, #3f4c6b)', borderRadius: '8px' }}>Out For Delivery</p> : <p className="font-weight-bold px-3 ml-2" style={{ background: 'linear-gradient(to right, #4b6cb7, #182848)', borderRadius: '8px' }}>Delivered</p>}
                        </div> */}

                        {/* <div className="d-flex " style={{ color: 'white' }}> Completion Status: {data.isCompleted == false ? <div className="  d-flex pl-2  font-weight-bolder"> <p className='font-weight-bold px-3' style={{ backgroundColor: '#DD011B', borderRadius: '8px', }}>Not Completed</p>    </div> : <div className="d-flex pl-2 " > <p className="font-weight-bold px-3" style={{ backgroundColor: '#30DF1E', borderRadius: '8px' }}>Completed</p>    </div>}
                        </div> */}
                        <h5 className="description">Product By: {data?.addedByEmail} - @{data?.addedByName}</h5>
                        <h5 className="description">Product Title: {data?.title}</h5>
                        <h5 className="description">Date: nAn</h5>
                        <div class="d-flex justify-content-between shadow-lg  rounded p-2" >
                            <div>
                                <img src={data?.media[0]} className="img-fluid" style={{ height: '100%', width: '100%' }} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between">

                            <h5 className="description" >Reviews:{reviews.length} </h5>
                            <h5 className="description d-flex">Ratings:{reviewRatings} </h5>
                        </div>

                        <h5 className="description d-flex">Category:{data?.category}  </h5>
                        <div className="d-flex justify-content-between">

                            <h5 className="description" >Printing Type:<p className="px-3 py-1" style={{ background: 'linear-gradient(90deg, rgba(0,159,253,1) 0%, rgba(42,42,114,1) 100%)', borderRadius: '8px' }} > {data?.printingType}</p> </h5>
                            <h5 className="description d-flex">Advertising:{data?.isAd == false ? <p>No</p> : <p>Yes</p>}  </h5>

                            {/* <h5 className="description">Price:{data?.price} AED </h5> */}
                        </div>
                        <h5 className="description d-flex">Sold:{data?.sold}  </h5>
                        <h5 className="description d-flex">Stock:{data?.stock >= 5555 ? <p>Unlimited</p> : data?.stock} -- {data?.stock} </h5>

                    </div>

                    {/* 
                    <div className="description" style={{ overflow: 'scroll', height: '200px' }}>Products:
                        {data?.products == '' ? <div className="d-flex justify-content-center align-items-center"> <p className="description " style={{ opacity: '0.5' }}>No Products!</p></div> : data?.products.map((pd) => {

                            return <div key={pd.id} className="my-2 ">
                                <div className="d-flex justify-content-between shadow-lg border rounded p-2">
                                    <div className="d-flex ">
                                        <div style={{ height: '50px' }}>
                                            <img src={pd.image} className="image-fluid" style={{ height: '100%', width: '100%' }} />
                                        </div>
                                        <div className="px-3">
                                            <p className=" font-weight-bolder ">{pd.name}</p>
                                           
                                            <div className="d-flex justify-content-between " >
                                                <p className=" font-weight-bolder" style={{ color: '#1CACE3' }}>AED</p>
                                                <p className=' pl-2 '>{pd.price} x {pd.quantity}</p>
                                            </div>




                                        </div>
                                    </div>

                                    <p className='flex-end'>Total Amount : {pd.totalPrice} AED</p>
                                </div>
                            </div>
                        })}
                    </div> */}

                </CardBody>
                <CardFooter>
                    <div className="button-container d-flex justify-content-around align-items-center">
                        <Link to={`/admin/Total-Products/Single-Product/${data?.id}`}>

                            <div className="btn btn-round" color="facebook">
                                See Product
                            </div>
                        </Link>
                        {/* <h4>Total Amount : {data?.amount} AED</h4> */}


                    </div>

                </CardFooter>
            </Card>

        </Col >

    );

}

export default ProductCard